// The Forcefield colours. They match --color-orange and --color-pink in V2.
export const FORCEFIELD_PALETTE = {
  accent: "#FFC2A9",
  primary: "#FF5714"
}
